const questionCategories = new Map([
  [
    "category1",
    [
      "Q1 当社の理念・ビジョンに共感している",
      "Q2 当社の経営目標とその実現方法は、社員に明示されている",
      "Q3 当社には将来性がある",
      "Q4 経営トップ層は、社員から信頼されている",
      "Q5 経営トップ層は、社員の声に耳を傾けている",
      "Q6 当社で働いていることに誇りを持っている",
      "Q7 当社が提供している商品・サービスが好きだ",
      "Q8 当社の雰囲気は、自分に合っている"
    ]
  ],
  [
    "category2",
    [
      "Q9 当社は、社員が過剰な労働時間とならないよう管理している",
      "Q10 当社は、社員が休憩時間や休日を確保できるよう管理している",
      "Q11 有給休暇は取得しやすく、十分消化している",
      "Q12 出産休暇や育児休暇、介護休暇など、各種休暇制度が整備され、取得されている",
      "Q13 社員の生活を充実させるような福利厚生の制度や施設が十分に整っている"
    ]
  ],
  [
    "category3",
    [
      "Q14 人事評価のしくみに納得している",
      "Q15 昇進・昇格のしくみに納得している",
      "Q16 当社では、社員の能力や適正に応じた人員配置を行っている",
      "Q17 当社では、知識や技術を高めたり資格を取得することによって、専門性の高いポジションにつく機会が用意されている"
    ]
  ],
  [
    "category4",
    [
      "Q18 給与や賞与の決定のしくみに納得している",
      "Q19 自分の給与は、仕事内容に照らして適切な水準である",
      "Q20 自分の給与は、同じ業種の違う会社と同等以上の水準である"
    ]
  ],
  [
    "category5",
    [
      "Q21 現在の上司は、職場の方向性についてメンバーに説明している",
      "Q22 現在の上司は、職場の目標を明確に示している",
      "Q23 現在の上司は、メンバー同士の役割分担を明確にしている",
      "Q24 現在の上司は、メンバーの知識、技術、経験を考慮して仕事を配分している",
      "Q25 職場には、実態に即した仕事のマニュアルが整備されている"
    ]
  ],
  [
    "category6",
    [
      "Q26 現在の上司は、職場の目標達成のために、メンバーの仕事を効果的に支援している",
      "Q27 現在の上司は、メンバーに対して能力開発のアドバイスをしている",
      "Q28 現在の上司は、メンバーのおかれている状況や心情に配慮している",
      "Q29 現在の上司は、メンバーの意見に十分に耳を傾けている",
      "Q30 現在の上司は、メンバーの評価を公正に行っている",
      "Q31 現在の上司は、信頼できる存在である"
    ]
  ],
  [
    "category7",
    [
      "Q32 職場の同僚とは、知識や情報を共有している",
      "Q33 職場の同僚とは、互いに助け合って仕事を進めている",
      "Q34 職場の同僚とは、自由で活発に意見交換をしている",
      "Q35 職場の同僚とは、お互いに信頼しあっている",
      "Q36 職場の同僚との人間関係は良好である"
    ]
  ],
  [
    "category8",
    [
      "Q37 必要な情報は関連部署と十分に共有されている",
      "Q38 職場では、関連部署に対する支援が惜しみなく行われている",
      "Q39 部署間の仕事上の連携はスムーズである"
    ]
  ],
  [
    "category9",
    [
      "Q40 職場は、清潔で衛生的である",
      "Q41 職場は、整理整頓されている",
      "Q42 職場には、効率的に仕事が行えるスペースが確保されている"
    ]
  ],
  [
    "category10",
    [
      "Q43 現在の仕事の中で、自分の能力を十分に発揮している",
      "Q44 現在の仕事をより効率的に行うための改善を行っている",
      "Q45 現在の仕事にやりがいを感じている",
      "Q46 現在の仕事の中で、達成感を感じている",
      "Q47 現在の仕事が好きだ",
      "Q48 現在の仕事に誇りを持っている"
    ]
  ],
  [
    "category11",
    [
      "Q49 業務量に対して、職場の人員数は十分足りている",
      "Q50 社員の業務負荷を軽減するような対策がとられている",
      "Q51 度を越した残業を強いられることはない",
      "Q52 現在の仕事の責任範囲は適切である(大きすぎない)",
      "Q53 仕事上で、過度なプレッシャーに悩まされることはない",
      "Q54 仕事上で、精神的・肉体的な疲労を強く感じることはない"
    ]
  ],
  [
    "category12",
    [
      "Q55 お客様の要望に応えられるよう、全力で努力している",
      "Q56 現在の仕事を通じて、お客様の役に立っている",
      "Q57 現在の仕事が、お客様の満足につながっているという実感がある",
      "Q58 お客様からのご意見・ご要望についての情報は、組織内で共有され、現場で活用されている"
    ]
  ],
  [
    "category13",
    [
      "Q59 仕事上で必要な知識や技術については、十分な教育や研修の機会が与えられている",
      "Q60 自分の成長につながる仕事にチャレンジする機会がある",
      "Q61 現在の仕事の中で、自分が成長しているという実感がある",
      "Q62 自分がやりたい将来の仕事は、現在の仕事の延長線上にある"
    ]
  ]
]);

export default questionCategories;



// WEBPACK FOOTER //
// ./src/utils/questionCategories.js